/* eslint-disable import/no-default-export, import/order, max-lines, no-nested-ternary, react/no-unescaped-entities, react/prop-types */
import { objNamesToSnakeCase } from "common/utils/helpers/cases";
import { submitDtfEvent } from "common/utils/mixpanel/submit-dtf-events";

const buildPayload = (eventProps: any) =>
  objNamesToSnakeCase({
    timestamp: Date.now(),
    ...eventProps
  });

export const trackTransfersPinsCtaClicked = ({ artworkId, sessionId }: any) => {
  submitDtfEvent(
    "transfers_pins_cta_clicked",
    buildPayload({
      artworkId,
      ...(sessionId && { sessionId })
    })
  );
};

export const trackPinsSessionSummaryEditClicked = ({ artworkId, sessionId }: any) => {
  submitDtfEvent(
    "pins_session_summary_edit_clicked",
    buildPayload({
      artworkId,
      sessionId
    })
  );
};

export const trackTransfersPinningInstructionsRemoved = ({ artworkId, sessionId }: any) => {
  submitDtfEvent(
    "transfers_pinning_instructions_removed",
    buildPayload({
      artworkId,
      sessionId
    })
  );
};

export const trackTransfersPinningModeEntered = ({
  artworkId,
  sessionId,
  hasExistingPins,
  initialMessage
}: any) => {
  submitDtfEvent(
    "transfers_pinning_mode_entered",
    buildPayload({
      artworkId,
      sessionId,
      hasExistingPins,
      ...(initialMessage && { initialMessage })
    })
  );
};

export const trackPinsSessionCancelled = ({
  artworkId,
  sessionId,
  pinsCount,
  readyPinsCount
}: any) => {
  submitDtfEvent(
    "pins_session_cancelled",
    buildPayload({
      artworkId,
      sessionId,
      pinsCount,
      readyPinsCount
    })
  );
};

export const trackPinsSessionCancellationAborted = ({ artworkId, sessionId, pinsCount }: any) => {
  submitDtfEvent(
    "pins_session_cancellation_aborted",
    buildPayload({
      artworkId,
      sessionId,
      pinsCount
    })
  );
};

export const trackPinsSessionEditCancelModalConfirmed = ({ sessionId, newPinsCount }: any) => {
  submitDtfEvent(
    "pins_session_edit_cancel_modal_confirmed",
    buildPayload({
      sessionId,
      newPinsCount
    })
  );
};

export const trackPinsSessionEditCancelModalStayed = ({ sessionId, newPinsCount }: any) => {
  submitDtfEvent(
    "pins_session_edit_cancel_modal_stayed",
    buildPayload({
      sessionId,
      newPinsCount
    })
  );
};

export const trackPinsSessionEditCancelFailed = ({
  sessionId,
  newPinsCount,
  errorMessage
}: any) => {
  submitDtfEvent(
    "pins_session_edit_cancel_failed",
    buildPayload({
      sessionId,
      newPinsCount,
      errorMessage
    })
  );
};

export const trackTransfersPinningSessionCompleted = ({
  artworkId,
  sessionId,
  pinsCount,
  readyPinsCount,
  summary
}: any) => {
  submitDtfEvent(
    "transfers_pinning_session_completed",
    buildPayload({
      artworkId,
      sessionId,
      pinsCount,
      readyPinsCount,
      summary
    })
  );
};

export const trackTransfersPinningSessionCompletionFailed = ({
  artworkId,
  sessionId,
  errorMessage
}: any) => {
  submitDtfEvent(
    "transfers_pinning_session_completion_failed",
    buildPayload({
      artworkId,
      sessionId,
      errorMessage
    })
  );
};

export const trackTransfersPinCreated = ({ artworkId, sessionId, pinId }: any) => {
  submitDtfEvent(
    "transfers_pin_created",
    buildPayload({
      artworkId,
      sessionId,
      pinId
    })
  );
};

export const trackTransfersPinMessageSubmitted = ({
  artworkId,
  sessionId,
  pinId,
  isFirstMessage,
  turnIndex,
  userMessagesCount,
  aiMessagesCount,
  clarifications
}: any) => {
  submitDtfEvent(
    "transfers_pin_message_submitted",
    buildPayload({
      artworkId,
      sessionId,
      pinId,
      isFirstMessage,
      turnIndex,
      userMessagesCount,
      aiMessagesCount,
      clarifications
    })
  );
};

export const trackTransfersPinClarificationClicked = ({
  artworkId,
  sessionId,
  pinId,
  optionValue,
  turnIndex,
  userMessagesCount,
  aiMessagesCount,
  optionType
}: any) => {
  submitDtfEvent(
    "transfers_pin_clarification_clicked",
    buildPayload({
      artworkId,
      sessionId,
      pinId,
      optionValue,
      turnIndex,
      userMessagesCount,
      aiMessagesCount,
      optionType
    })
  );
};

export const trackTransfersPinReady = ({
  artworkId,
  sessionId,
  pinId,
  userMessagesCount,
  aiMessagesCount
}: any) => {
  submitDtfEvent(
    "transfers_pin_ready",
    buildPayload({
      artworkId,
      sessionId,
      pinId,
      userMessagesCount,
      aiMessagesCount
    })
  );
};

export const trackTransfersPinUnsupported = ({
  artworkId,
  sessionId,
  pinId,
  userMessagesCount,
  aiMessagesCount
}: any) => {
  submitDtfEvent(
    "transfers_pin_unsupported",
    buildPayload({
      artworkId,
      sessionId,
      pinId,
      userMessagesCount,
      aiMessagesCount
    })
  );
};

export const trackTransfersPinNeedsClarification = ({
  artworkId,
  sessionId,
  pinId,
  optionsCount,
  questionType,
  userMessagesCount,
  aiMessagesCount
}: any) => {
  submitDtfEvent(
    "transfers_pin_needs_clarification",
    buildPayload({
      artworkId,
      sessionId,
      pinId,
      optionsCount,
      ...(questionType && { questionType }),
      userMessagesCount,
      aiMessagesCount
    })
  );
};

export const trackTransfersPinError = ({
  artworkId,
  sessionId,
  pinId,
  errorType,
  userMessagesCount,
  aiMessagesCount
}: any) => {
  submitDtfEvent(
    "transfers_pin_error",
    buildPayload({
      artworkId,
      sessionId,
      pinId,
      errorType,
      userMessagesCount,
      aiMessagesCount
    })
  );
};

export const trackTransfersPinSelected = ({
  artworkId,
  sessionId,
  pinId,
  previousPinId,
  pinState
}: any) => {
  submitDtfEvent(
    "transfers_pin_selected",
    buildPayload({
      artworkId,
      sessionId,
      pinId,
      ...(previousPinId && { previousPinId }),
      pinState
    })
  );
};

export const trackTransfersPinDeleted = ({
  artworkId,
  sessionId,
  pinId,
  pinState,
  hadMessages
}: any) => {
  submitDtfEvent(
    "transfers_pin_deleted",
    buildPayload({
      artworkId,
      sessionId,
      pinId,
      pinState,
      hadMessages
    })
  );
};

export const trackTransfersPinDeleteFailed = ({ artworkId, sessionId, pinId }: any) => {
  submitDtfEvent(
    "transfers_pin_delete_failed",
    buildPayload({
      artworkId,
      sessionId,
      pinId
    })
  );
};

export const trackPinSessionEscapeHatchClicked = ({ triggerType, pinCount, messageCount }: any) => {
  submitDtfEvent(
    "pin_session_escape_hatch_clicked",
    buildPayload({
      triggerType,
      pinCount,
      messageCount
    })
  );
};

export const trackPinSessionEscapeHatchConfirmed = ({
  triggerType,
  pinCount,
  messageCount
}: any) => {
  submitDtfEvent(
    "pin_session_escape_hatch_confirmed",
    buildPayload({
      triggerType,
      pinCount,
      messageCount
    })
  );
};

export const trackPinSessionEscapeHatchDismissed = ({
  triggerType,
  pinCount,
  messageCount
}: any) => {
  submitDtfEvent(
    "pin_session_escape_hatch_dismissed",
    buildPayload({
      triggerType,
      pinCount,
      messageCount
    })
  );
};

export const trackTransfersPinningSessionEntryInput = ({ artworkId, inputValue }: any) => {
  submitDtfEvent(
    "pinning_session_entry_input",
    buildPayload({ artworkId, placement: null, input: inputValue })
  );
};

export const trackPinSessionsGenPreviewBeforeClicked = ({
  artworkId,
  sessionId,
  generatedImageUrl
}: any) => {
  submitDtfEvent(
    "pin_sessions_gen_preview_before_clicked",
    buildPayload({ artworkId, sessionId, generatedImageUrl })
  );
};

export const trackPinSessionsGenPreviewAfterClicked = ({
  artworkId,
  sessionId,
  generatedImageUrl
}: any) => {
  submitDtfEvent(
    "pin_sessions_gen_preview_after_clicked",
    buildPayload({ artworkId, sessionId, generatedImageUrl })
  );
};

export const trackPinSessionsGenConfirmed = ({ artworkId, sessionId, pinId }: any) => {
  submitDtfEvent("pin_sessions_gen_confirmed", buildPayload({ artworkId, sessionId, pinId }));
};

export const trackPinSessionsGenDiscarded = ({ artworkId, sessionId, pinId }: any) => {
  submitDtfEvent("pin_sessions_gen_discarded", buildPayload({ artworkId, sessionId, pinId }));
};

export const trackPinSessionGeneratedImageShown = ({
  artworkId,
  sessionId,
  generatedImageUrl,
  pinId
}: any) => {
  submitDtfEvent(
    "pin_session_generated_image_shown",
    buildPayload({ artworkId, sessionId, generatedImageUrl, pinId })
  );
};

export const trackTransfersArtistEditEscalationShown = ({ artworkId, sessionId, pinId }: any) => {
  submitDtfEvent(
    "transfers_artist_edit_escalation_shown",
    buildPayload({ artworkId, sessionId, pinId })
  );
};
